import querystring from 'querystring'
import staticContents from './staticContent'

import type { ArticleProviderProps } from '../provider/ArticleProvider'
import type { Language } from '@/siteBuilder/locale'

const validateCategory = (selectedCategory: string, categories: ArticleProviderProps['categories']) =>
  categories.findIndex((category) => category.fields.name.toLowerCase() === selectedCategory.toLowerCase()) !== -1

const findSelectedCategory = (url: string, categories: ArticleProviderProps['categories'], lang: Language) => {
  const queryString = url && url.split('?') && url.split('?').length > 1 && url.split('?')[1]

  const parsedQS = querystring.decode(queryString) as { category: string }

  let selectedCategory: string

  if (url?.includes('category')) {
    selectedCategory =
      (parsedQS && parsedQS.category && parsedQS.category !== 'covid-19'
        ? parsedQS.category.replaceAll('-', ' ')
        : parsedQS.category) || staticContents.ALL[lang]

    const isSelectedCategoryValid = validateCategory(selectedCategory, categories) // if user passes invalid category to query params,
    // we use 'all' instead of returning error
    if (!isSelectedCategoryValid) {
      selectedCategory = staticContents.ALL[lang]
    }
  } else {
    selectedCategory = staticContents.ALL[lang]
  }

  return selectedCategory
}

export default findSelectedCategory
